import { TextAnimations } from "@/modules/text-animations";
import { DotsAnimation } from "@/modules/dots-animation";
import { PurposeProgress } from "@/modules/purpose-progress";
import { LiquidityProgress } from "@/modules/liquidity-progress";
import { Counter } from "@/modules/counter";
import { CardBorder } from "@/modules/card-border";
import { CoinsGravity } from "@/modules/coins-gravity";
import { LogosWheel } from "@/modules/logos-wheel";
import { Accordion } from "@/modules/accordion";
import { CoinsAnimation } from "@/modules/coins-animation";

const homeWindow = window as Window & {
  __thresholdHomeNoncriticalLoaded?: boolean;
};

if (!homeWindow.__thresholdHomeNoncriticalLoaded) {
  homeWindow.__thresholdHomeNoncriticalLoaded = true;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const textAnimations = new TextAnimations(
    "#main > section:not(#heroSection) [data-split-inview], #footerSection [data-split-inview]"
  );
  textAnimations.init();

  const footerDotsAnimation = new DotsAnimation("#footerSection [data-dots]");
  footerDotsAnimation.init();

  const purposeProgress = new PurposeProgress();
  purposeProgress.init();
  const liquidityProgress = new LiquidityProgress();
  liquidityProgress.init();
  const counter = new Counter();
  counter.init();
  const cardBorder = new CardBorder();
  cardBorder.init();
  const coinsGravity = new CoinsGravity();
  coinsGravity.init();
  const logosWheel = new LogosWheel();
  logosWheel.init();
  const accordion = new Accordion();
  accordion.init();

  if (!reduceMotion) {
    const footer = document.getElementById("footerSection");

    if (footer) {
      const initFooterCoins = () => {
        const footerCoins = new CoinsAnimation("riveFooter", "footerSection", -0.8, "top bottom", "bottom 20%");
        footerCoins.init();
      };

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          initFooterCoins();
          observer.disconnect();
        }, { rootMargin: "400px" });

        observer.observe(footer);
      } else {
        initFooterCoins();
      }
    }
  }

  window.addEventListener("accordion:toggle", (e) => {
    const customEvent = e as CustomEvent;
    coinsGravity.triggerJump(customEvent.detail.force);
  });
}
